import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const pctRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.pctEvents,
    name: routeNames.pctEvents,
    component: () => import('@/pages/pct/PctPracticeView.vue'),
    meta: {
      permission: 'pct.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'assured_workload',
      labelKey: 'pctEvents',
      featureFlag: 'pct',
    },
  },
  {
    path: routePaths.pctDeposits,
    name: routeNames.pctDeposits,
    component: () => import('@/pages/pct/PctDepositsView.vue'),
    meta: {
      permission: 'pct.write.assigned',
      icon: 'material-symbols-outlined',
      iconText: 'drive_folder_upload',
      labelKey: 'pctDeposits',
      featureFlag: 'pct',
    },
  },
  {
    path: routePaths.pctDepositDetails,
    name: routeNames.pctDepositDetails,
    component: () => import('@/pages/pct/PctDepositDetailsView.vue'),
    meta: {
      permission: 'pct.write.assigned',
      featureFlag: 'pct',
    },
  },
  {
    path: routePaths.pctDepositParties,
    name: routeNames.pctDepositParties,
    redirect: { name: routeNames.pctDepositDetails },
    meta: {
      permission: 'pct.write.assigned',
      labelKey: 'parties',
      featureFlag: 'pct',
    },
  },
  {
    path: routePaths.pctDepositAddParty,
    name: routeNames.pctDepositAddParty,
    component: () => import('@/pages/pct/AddPctDepositPartyView.vue'),
    meta: {
      permission: 'pct.write.assigned',
      labelKey: 'new_f',
      featureFlag: 'pct',
    },
  },
  {
    path: routePaths.pctDepositCreation,
    name: routeNames.pctDepositCreation,
    component: () => import('@/pages/pct/AddPctDepositView.vue'),
    meta: {
      permission: 'pct.write.assigned',
      labelKey: 'new_m',
      featureFlag: 'pct',
    },
  },
]
